import { useLocation } from "react-router-dom";
import { useEffect } from "react";

let currentPath = "/";

export const getCurrentPath = () => currentPath;

export const RouteEvent = () => {
  const location = useLocation();

  useEffect(() => {
    currentPath = location.pathname;
  }, [location]);

  return null;
};
